export const REPORT_VERSION_NAMING_KEY = 'monsurv_report_version_naming';

export function normalizeReportVersionNaming(value) {
    const v = String(value || '').trim().toLowerCase();
    if (v === 'lettered' || v === 'letters' || v === 'letter') return 'lettered';
    if (v === 'numbered' || v === 'numbers' || v === 'number') return 'numbered';
    return 'numbered';
}

export function getReportVersionNaming() {
    try {
        return normalizeReportVersionNaming(localStorage.getItem(REPORT_VERSION_NAMING_KEY));
    } catch {
        return 'numbered';
    }
}

export function getReportVersionNoun(naming) {
    return normalizeReportVersionNaming(naming) === 'lettered' ? 'Revision' : 'Version';
}

export function numberToLetters(n) {
    const num = Number(n);
    if (!Number.isFinite(num) || num <= 0) return '';

    // 1 -> A, 2 -> B, ... 26 -> Z, 27 -> AA, ...
    let x = Math.floor(num);
    let out = '';
    while (x > 0) {
        x -= 1;
        out = String.fromCharCode(65 + (x % 26)) + out;
        x = Math.floor(x / 26);
    }
    return out;
}

export function formatReportVersion(revision, naming) {
    const rev = revision != null && Number.isFinite(Number(revision)) ? Number(revision) : null;
    if (rev == null) return '';

    const scheme = normalizeReportVersionNaming(naming);
    if (scheme === 'lettered') {
        const letters = numberToLetters(rev);
        return letters ? `Revision ${letters}` : `Revision ${rev}`;
    }

    return `Version ${rev}`;
}

export function formatReportVersionValue(revision, naming) {
    const rev = revision != null && Number.isFinite(Number(revision)) ? Number(revision) : null;
    if (rev == null) return '—';

    const scheme = normalizeReportVersionNaming(naming);
    if (scheme === 'lettered') return numberToLetters(rev) || String(rev);
    return String(rev);
}
